<template>
  <div class="home">
    <div class="slides" id="slides" ref="slides">
      <div class="slide" v-for="(slide, index) in slideList" :key="index" :class="{'slide-active': slides.active == index }">
        <div class="wrapper">
            <div class="bgs" v-if="slide.bgimage" :style="slide.style"></div>
          <div class="slide-info" style="z-index: 1;">
            <h1>{{ slide.title }}</h1>
            <h3>{{ slide.subtitle }}</h3>
            <div class="buttons">              
              <router-link :to="slide.url" tag="button" class="button">{{ slide.button }}</router-link>
              <!-- <button type="button">Faça um orçamento</button> -->
            </div>
          </div>
          <div class="slide-image" v-if="slide.image">
            <img v-if="!slide.bgimage" :src="slide.image.url" :alt="slide.title" style="max-width: 100%">
          </div>
        </div>
      </div>
      
      <div class="nav">
        <a v-for="(slide, index) in slides.list" :key="index" href="javascript:void(0)" @click="slides.active = index" :class="{'active': slides.active == index }">{{ slide.id }}</a>
        <!-- <a href="javascript:void(0)" @click="slides.active = 1" :class="{'active': slides.active == 1 }">Moldes</a> -->
      </div>
    </div>
        
        <!-- <h2 class="text-center title">Descubra</h2> -->
        <!-- <h4 class="text-center subtitle">Melhoramos</h4> -->
        <discover v-if="!sections.loading && sections.list.length" :discover="sections.list"></discover>
    <!-- <div class="advantages">
        
      <h2 class="text-center title">Diferenciais</h2>
      <h4 class="text-center subtitle">Algumas das principais características</h4>
      <div class="wrapper flex-between">
      <div class="advantage double">
        <div class="advantage-image">
          <img src="https://firebasestorage.googleapis.com/v0/b/vacuum-center.appspot.com/o/public%2Fpneumatico.jpg?alt=media&token=98870ab7-038f-44bf-98a3-16700cafbf8f" alt="Sistemas pneumáticos">
        </div>
        <div class="advantage-info">
          <h2>Sistemas Pneumáticos</h2>
          <h4>São super eficientes, e possuem boa relação custo x benefício</h4>
        </div>
      </div>
      <div class="advantage">
        <div class="advantage-image">
          <img src="https://firebasestorage.googleapis.com/v0/b/vacuum-center.appspot.com/o/public%2Fpainel.jpg?alt=media&token=6a1feab1-88be-442c-921d-b21e4ab50c2a" alt="Painel operacional">
        </div>
        <div class="advantage-info">
          <h2>Painel Operacional</h2>
          <h4>Programação avançada e intuitiva</h4>
        </div>
      </div>
      <div class="advantage">
        <div class="advantage-image">
          <img src="https://firebasestorage.googleapis.com/v0/b/vacuum-center.appspot.com/o/public%2Fmoldes.jpg?alt=media&token=07ed96c2-1fc5-4fc7-81ba-67567a78aad1" alt="Moldes">
        </div>
        <div class="advantage-info">
          <h2>Moldes &amp; Cia</h2>
          <h4>Ferramentas de vácuo e selagem</h4>
        </div>
      </div>
      </div>
    </div> -->
    <div class="categories">
      <h2 class="text-center title">Conheça nossas máquinas</h2>
      <!-- <h4 class="text-center subtitle">Categorias</h4> -->
      <div class="wrapper flex-center">
      <div class="category card">
        <div class="category-image card-image">
          <img src="https://firebasestorage.googleapis.com/v0/b/vacuum-center.appspot.com/o/public%2Fcat-seladoras.jpg?alt=media&token=5157a7fe-f313-4844-b667-61786d3e1de5" alt="Seladoras de blister">
        </div>
        <div class="category-info card-info">
          <h2 class="text-center">Seladora de blister</h2>
          <h4 class="text-center">Máquinas seladoras de blister de esteira, giro, carrinho ou pneumática</h4>
          <router-link to="/maquinas?refinementList%5Bcategory.name%5D%5B0%5D=Seladora%20de%20Blister" tag="button" class="button">Ver máquinas</router-link>
        </div>
      </div>
      <div class="category card">
        <div class="category-image card-image">
          <img src="https://firebasestorage.googleapis.com/v0/b/vacuum-center.appspot.com/o/public%2Fcat-vacuumforming.jpg?alt=media&token=f727b21a-f1b5-435e-a96e-d07a6ef77cbf" alt="Vacuum Forming">
        </div>
        <div class="category-info card-info">
          <h2 class="text-center">Vacuum Forming</h2>
          <h4 class="text-center">Máquinas termoformadoras. Robustez e velocidade na sua produção</h4>
          <router-link to="/maquinas?refinementList%5Bcategory.name%5D%5B0%5D=Vacuum%20Forming" tag="button" class="button">Ver máquinas</router-link>
        </div>
      </div>
      <div class="category card">
        <div class="category-image card-image">
          <img src="https://firebasestorage.googleapis.com/v0/b/vacuum-center.appspot.com/o/public%2Fcat-corte.jpg?alt=media&token=2d82e83c-6464-4b61-81aa-d5fc07bf0a2c" alt="Máquinas de corte">
        </div>
        <div class="category-info card-info">
          <h2 class="text-center">Máquinas de Corte</h2>
          <h4 class="text-center"></h4>
          <router-link to="/maquinas?refinementList%5Bcategory.name%5D%5B0%5D=Corte" tag="button" class="button">Ver máquinas</router-link>
        </div>
      </div>
      <router-link to="/maquinas" tag="div" class="category card card-blue">
        <div class="category-info card-info">
          <h2 style="color: #fff">Ver todos os modelos</h2>
          <h4 class="text-center"><i class="ico-arrow_forward"></i></h4>
        </div>
      </router-link>
    </div>
    </div>
    <div class="advantages">
        <div class="wrapper flex-center icons">
            <router-link :to="`/servicos/#${service.name}`" tag="div" class="icon" v-for="(service, index) in services.list" :key="index">
                <h1><i :class="service.class"></i></h1>
                <h2>{{ service.name}}</h2>
            </router-link>
        </div>
    </div>
    <get-in-touch></get-in-touch>
  </div>


  
</template>

<script>
import Discover from '../components/Discover.vue'
import GetInTouch from '../components/GetInTouch.vue'

export default {
  name: 'Home',
  components: {
      Discover,
      GetInTouch
  },
  computed: {
      slideList(){
          let slides = []
          this.slides.list.forEach((slide) => {
              console.log(slide)
              slide.style = {'width': '100vw', 'height': '100vh', 'z-index': 0, 'position': 'absolute', 'top': 0, 'left': 0, 'background': 'url(' + slide.image.url +')', 'background-size': 'cover', 'background-position': 'center'}
              slides.push(slide)
          })
          return slides
      }
  },
  data() {
    return {
      slides: {
          list: [],
          loading: false,
        active: 0,
        timeout: 3000
      },
      sections: {
          list: [],
          loading: false,
      },
      services: {
          list: [],
          loading: false,
      },
      form: {
        name: "",
        email: "",
        createdAt: ""
      },
      errors: {
        name: [],
        email: []
      },
      subscriberStatus: null,
      offset: 0,
      scrolled: 0
    }
  },
  firestore () {
        return {
            slidesTg: this.$db.collection("slides").where("status", "==", true)
            .get().then((snap) => {
                let slides = []
                this.slides.loading = true
                snap.forEach((doc) => {
                    let data = doc.data()
                    data.docId = doc.id
                    // data.image = 'url(' + data.image.url + ')'
                    slides.push(data)
                });
                this.slides.list = slides
                this.slides.loading = false
            }),
            sectionsTg: this.$db.collection("sections")
            .where("status", "==", true)
            .get().then((snap) => {
                let sections = []
                this.sections.loading = true
                snap.forEach((doc) => {
                    let data = doc.data()
                    data.docId = doc.id
                    sections.push(data)
                });
                this.sections.list = sections
                this.sections.loading = false
            }),
            servicesTg: this.$db.collection("services").get().then((snap) => {
                let service = []
                this.services.loading = true
                snap.forEach((doc) => {
                    let data = doc.data()
                    data.docId = doc.id
                    service.push(data)
                });
                this.services.list = service
                this.services.loading = false
            })
        }
    },
  mounted () {
   this.matchHeight()
 },


  created(){
    this.$root.isInvisible = true;
  },
  methods: {
     matchHeight () {
      this.offset = this.$refs.slides.clientHeight
      this.onScroll()
      window.addEventListener('scroll', this.onScroll, false)
    },
    onScroll(){
      
        this.scrolled = window.scrollY
        let offset = this.offset - 140
        this.$root.isInvisible = (window.scrollY < offset)
    }
  }
}; 

</script>
<style scoped>
    .icons{
        padding: 10px 60px;
    }
    .icon{
        flex: 1 1 25%;
        padding: 10px 0;
        border-left: 1px solid #ced2de;
        text-align: center;
        margin: 0;
        transition: .3s all;
    }
    .icon:first-child{
        border-left: 1px solid transparent;

    }
    .icon:hover{
        background: #fff;
    }
    .icon h1{
        color: #ced2de;
    }
    .icon h2{
        color: #7d838f;
    }

</style>